/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Embed(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Embed',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 20 * scale,
      viewBox: '0 0 20 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","d":"m4.042 10.436 4.064-4.4L5.902 4l-5.944 6.436 5.944 6.435 2.204-2.036-4.064-4.4zm11.92 0-4.064-4.4L14.102 4l5.944 6.436-5.944 6.434-2.204-2.035z","fill":"currentColor"}))
}
